import {Error, ValidationResult, Validator} from '@/type/validation/result';

import {半角カナ禁止, 必須入力, 日付書式} from '@/type/validation/validator';
import {破棄破損履歴検索条件型} from '@/type/destroy/records/history/破棄破損履歴検索条件型';

export default class 破棄破損履歴検索条件入力チェッカー {
  単項目チェック結果: Error[];
  相関チェック結果: Error[];

  constructor(target: 破棄破損履歴検索条件型) {
    const 単項目チェック = new ValidationResult(単項目チェックvalidators);
    単項目チェック.validate(target);
    this.単項目チェック結果 = 単項目チェック.getErrors;
    const 破棄破損日範囲エラー = 破棄破損日範囲のFROMがTOより小(target);
    this.相関チェック結果 = 破棄破損日範囲エラー;
  }

  hasErrors(): boolean {
    return this.単項目チェック結果.length > 0 || this.相関チェック結果.length > 0;
  }

  hasError(name: string): boolean {
    return this.単項目チェック結果.some((error) => (error.name === name && error.index === 0));
  }

  errorMessages(): string[] {
    return this.単項目チェック結果.concat(this.相関チェック結果)
      .map((value) => `${value.message}`);
  }
}

const 商品名カナValidator = {
  name: '商品名カナ',
  constraints: [
    {method: 半角カナ禁止, message: '商品名カナに半角カナが含まれています'},
  ],
};
const 破棄破損日FromValidator = {
  name: '破棄破損日FROM',
  constraints: [
    {method: 必須入力, message: '破棄破損日の開始日は入力必須項目です'},
    {method: 日付書式, message: '破棄破損日の書式を正しく入力してください'},
  ],
};

const 破棄破損日ToValidator = {
  name: '破棄破損日TO',
  constraints: [
    {method: 日付書式, message: '破棄破損日の書式を正しく入力してください'},
  ],
};

const 単項目チェックvalidators: Validator[] = [
  商品名カナValidator,
  破棄破損日FromValidator,
  破棄破損日ToValidator,
];

function 破棄破損日範囲のFROMがTOより小(target: 破棄破損履歴検索条件型): Error[] {
  const errors: Error[] = [];
  if (target.破棄破損日FROM === null || target.破棄破損日TO === null) return errors;
  if (target.破棄破損日FROM.valueOf() > target.破棄破損日TO.valueOf()) {
    errors.push({index: 0, message: '破棄破損日の範囲指定が間違っています', constraint: '', name: '破棄破損日範囲エラー'});
  }
  return errors;
}
